// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"d19ac373","296":"d449e130","378":"44e5e2c6","840":"1c93c144"}[chunkId] + ".chunk.css";
};